import React, { useEffect } from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import RtoIcon from "./images/rto.svg";
import { DIY_DOCUMENT_VERFIFICATION_STATES } from "../post-inspection-diy/constant";
import { getDocumentList } from "../post-inspection-diy-pickup-things-to-do/selector";
import PostInspectionDiyCardHandoverDocumentCard from "../post-inspection-diy-car-handover-document-card";

const PostInspectionDiyPickupRtoDocuments = ({
    isStandAlone = true,
    doctet,
    getPickupDocumentsConnect
}) => {
    const { pickupDocuments = {} } = doctet || {};
    const data = getDocumentList(pickupDocuments, isStandAlone);
    const {
        isMandatoryDocRejected,
        isNonMandatoryDocRejected,
        allRtoDocuments = []
    } = data || {};

    useEffect(() => {
        if (isStandAlone) {
            if (isMandatoryDocRejected) {
                if (isNonMandatoryDocRejected) {
                    getPickupDocumentsConnect({status: DIY_DOCUMENT_VERFIFICATION_STATES.REJECTED_WITH_HOLD});
                } else {
                    getPickupDocumentsConnect({status: DIY_DOCUMENT_VERFIFICATION_STATES.REJECTED});
                }
            } else if (isNonMandatoryDocRejected) {
                getPickupDocumentsConnect({status: DIY_DOCUMENT_VERFIFICATION_STATES.APPROVED_WITH_HOLD});
            }
        }
    }, [getPickupDocumentsConnect, isMandatoryDocRejected, isNonMandatoryDocRejected, isStandAlone]);

    return (
        <React.Fragment>
            <div styleName={"styles.rtoDocList"}>
                <div styleName={"styles.rtoDocumentCard"}>
                    <h3>RTO Documents</h3>
                    <div styleName={"styles.rtoIconCard"}>
                        <img src={RtoIcon} alt="rto" />
                        <h4>Help Driver in verification of<br /> RTO documents</h4>
                    </div>
                    <PostInspectionDiyCardHandoverDocumentCard
                        docList={allRtoDocuments}
                        isStandAlone={isStandAlone}
                    />
                </div>
            </div>
        </React.Fragment>
    );
};

PostInspectionDiyPickupRtoDocuments.propTypes = {
    isStandAlone: PropTypes.bool,
    doctet: PropTypes.object,
    inspectionResponse: PropTypes.object,
    getPickupDocumentsConnect: PropTypes.func,
    carDetails: PropTypes.object,
    activeTab: PropTypes.any,
    setActiveTabConnect: PropTypes.func
};

export default PostInspectionDiyPickupRtoDocuments;
